export const MAX_WIDTH = 1000;
export const MAX_WIDTH_STR = "1000px";

export const MAIN_URL = "../ecomic/index.html";


const size = {
	mobileS: '320px',
	mobileM: '375px',
	mobileL: '425px',
	tablet: '768px',
	laptop: '1024px',
	laptopL: '1440px',
	desktop: '2560px'
};

export const device = {
	mobileS: `(max-width: ${size.mobileS})`,
	mobileM: `(min-width: ${size.mobileS}) and (max-width: ${size.mobileM})`,
	mobileL: `(min-width: ${size.mobileM}) and (max-width: ${size.mobileL})`,
	tablet: `(min-width: ${size.mobileL}) and (max-width: ${size.tablet})`,
	laptop: `(min-width: ${size.tablet}) and (max-width: ${size.laptop})`,
	laptopL: `(min-width: ${size.laptop}) and (max-width: ${size.laptopL})`,
	desktop: `(min-width: ${size.laptopL}) and (max-width: ${size.desktop})`,
	desktopL: `(min-width: ${size.desktop})`
};